<div id="dropdown-backdrop"></div>
<header class="header bg-dark pt-1 pt-sm-0">
  <nav class="navbar navbar-expand-lg navbar-dark ps-sm-7px pt-sm-2q pe-sm-11px pb-sm-14px px-lg-1 py-lg-0">
    <div class="container">
      <div class="w-100 flex-lg-column px-lg-2">
        <div class="d-flex justify-content-between w-100">
          <a class="navbar-brand me-lg-auto pt-sm-0 pb-sm-0 pt-lg-0h"
             routerLink="/"
             aria-label="Ir para a página inicial"
             title="Ir para a página inicial">
            <app-image name="logo-mercedes" type="svg" height="56" width="207" classes="img-logo-mercedes" alt="Logo Mercedes-Benz" title="Logo Mercedes-Benz"></app-image>
          </a>
          <a href="https://rodobens.com.br/"
             target="_blank"
             aria-label="Ir para a página inicial da Rodobens"
             title="Ir para a página inicial da Rodobens">
            <app-image name="logo-rodobens" type="svg" height="37" width="180" classes="img-contain d-none d-lg-inline-block pt-lg-39px me-lg-15px" alt="Logo da Rodobens" title="Logo da Rodobens"></app-image>
          </a>
          <app-image name="logo-shield" type="svg" height="30" width="143" classes="img-contain mb-0h mb-lg-12px d-none d-lg-inline-block pt-lg-39px" alt="Logo Mercedes-Benz" title="Logo Mercedes-Benz"></app-image>
          <button class="navbar-toggler ms-auto align-self-sm-end align-self-lg-center"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            <img src="/assets/images/icons/ic-close.svg"
                 width="17.19"
                 height="17.19"
                 class="img-fluid"
                 alt="Menu">
          </button>
        </div>
        <div id="blue-line" class="d-none d-lg-block w-100"
             style="margin: 0.9375rem 0 0.5rem 0; border: 1px solid #262626"></div>
        <div class="me-lg-auto flex-grow-1 flex-lg-grow-0">
          <div class="navbar-collapse px-1 p-lg-0 collapse"
               id="navbarNavDropdown">
            <ul class="navbar-nav mb-2 mb-sm-77px mb-lg-0">
              <li class="nav-item dropdown d-none d-lg-block">
                <a class="nav-link dropdown-toggle ps-lg-0 remove-arrow pe-lg-17px"
                   id="navbarDropdownWorldLink"
                   role="button"
                   data-bs-toggle="dropdown"
                   aria-haspopup="true"
                   aria-expanded="false">
                  <img src="/assets/images/icons/ic-menu.svg"
                       loading="lazy"
                       width="13"
                       height="12"
                       class="img-fluid d-none d-lg-inline-block"
                       alt="Menu">
                </a>
                <div class="dropdown-menu dropdown-primary px-2q px-lg-25px light-text"
                     aria-labelledby="navbarDropdownWorldLink">
                  <a class="ms-auto d-none d-lg-block text-end pt-lg-7px"
                     role="button"
                     data-bs-toggle="dropdown"
                     data-bs-target="#navbarDropdownWorldLink"
                     aria-haspopup="true"
                     aria-expanded="false">
                    <img src="/assets/images/icons/ic-close.svg"
                         loading="lazy"
                         width="14"
                         height="23"
                         class="img-fluid"
                         alt="Menu">
                  </a>
                  <div
                      class="d-none d-lg-block dropdown-menu-title a-light-text text-black fs-lg-25 mt-lg-0h mb-lg-31px px-lg-11px">
                    Mundo Mercedes-Benz
                  </div>
                  <ng-container *ngFor="let linkMercedesWorld of linksMercedesWorld; let first = first">
                    <a class="dropdown-item text-gray-tint-1 fs-16 fs-lg-14"
                       [ngClass]="first ? 'pt-0 pb-lg-11px px-lg-11px' : 'p-lg-11px'"
                       [attr.aria-label]="linkMercedesWorld.label"
                       [title]="linkMercedesWorld.title"
                       [href]="linkMercedesWorld.href"
                       target="_blank"
                       rel="noopener">
                      {{ linkMercedesWorld.label }}
                    </a>
                  </ng-container>
                </div>
              </li>
              <li *ngFor="let menu of menus; let index = index"
                  class="nav-item"
                  [ngClass]="menu.submenus ? 'dropdown' : ''">
                <a *ngIf="!menu.submenus;else menuDropdown"
                   class="nav-link s-pro-text py-sm-0 py-lg-10px lh-sm-228p lh-lg-1h fs-sm-35 fs-lg-14"
                   [href]="menu.url"
                   [attr.aria-label]="menu.nome"
                   [title]="menu.nome"
                   [class.pt-sm-57px]="index == 0">
                  {{menu.nome}}
                </a>
                <ng-template #menuDropdown>
                  <a class="nav-link s-pro-text dropdown-toggle py-sm-0 py-lg-10px lh-sm-228p lh-lg-1h fs-sm-35 fs-lg-14"
                     [href]="menu.url"
                     [attr.aria-label]="menu.nome"
                     [title]="menu.nome"
                     [id]="menu.id"
                     role="button"
                     data-bs-toggle="dropdown"
                     aria-haspopup="true"
                     aria-expanded="false">
                    {{menu.nome}}
                  </a>
                  <div class="dropdown-menu px-1 light-text"
                       [attr.aria-labelledby]="menu.id">
                    <a *ngFor="let submenu of menu.submenus"
                       class="dropdown-item"
                       [attr.aria-label]="submenu.nome"
                       [title]="submenu.nome"
                       [href]="submenu.url"
                       [target]="submenu.target"
                       rel="noopener">
                      {{submenu.nome}}
                    </a>
                  </div>
                </ng-template>
              </li>
            </ul>
            <div class="d-lg-none py-2 py-sm-67px py-lg-2 dropdown-primary mobile-options light-text text-primary"
                 aria-labelledby="navbarDropdownWorldLink">
              <a class="ms-auto d-none d-lg-block text-end"
                 role="button"
                 data-bs-toggle="dropdown"
                 data-bs-target="#navbarDropdownWorldLink"
                 aria-haspopup="true"
                 aria-expanded="false">
                <img src="/assets/images/icons/ic-close.svg"
                     loading="lazy"
                     width="14"
                     height="23"
                     class="img-fluid"
                     alt="Menu">
              </a>
              <div class="position-relative">
                <div class="mb-1 dropdown-menu-title title-text fs-25 mt-lg-1h mb-lg-2q">
                  Mundo Mercedes-Benz
                </div>
                <ng-container *ngFor="let linkMercedesWorld of linksMercedesWorld">
                  <a class="dropdown-item text-primary"
                     [attr.aria-label]="linkMercedesWorld.label"
                     [title]="linkMercedesWorld.title"
                     [href]="linkMercedesWorld.href"
                     target="_blank"
                     rel="noopener">
                    {{ linkMercedesWorld.label }}
                  </a>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
